import {config} from "../environment";
import {useAsync} from "../utils/utils";
import {PlassSakInfo} from "./plassSaker";

type BarnehageplassStatusResponse = {
    barn: Array<BarnBarnehageplassStatus>
}

export type BarnBarnehageplassStatus = {
    ident: string,
    navn: string,
    statusCard: StatusCard
    barnehageplasser?: Array<Barnehageplass>
}

export type StatusCardType =
    "STÅENDE_TILBUD"
    | "GODTATT_TILBUD"
    | "AVSLÅTT_TILBUD"
    | "UTGÅTT_TILBUD"
    | "PLASSERT"
    | "MOTTATT_SØKNAD"
    | "SØKNADSFRIST"
    | "UKJENT"

export type StatusCard = {
    type: StatusCardType
    sak: PlassSakInfo | null
    søknadsfrist: string | null
}

export type Barnehageplass = {
    barnehageNavn: string
    startDato: string
    sluttDato?: string
}

async function getBarnehageplassStatus(): Promise<Array<BarnBarnehageplassStatus>> {
    return fetch(`${config.apiUrl}/api/barnehageplass/barnehageplass-status`)
        .then(res => res.json() as Promise<BarnehageplassStatusResponse>)
        .then(json => json.barn)
}

export const useGetBarnBarnehageplassStatus = useAsync(getBarnehageplassStatus)
